(() => {
  const init = (root = document) => {
    const pages = root.matches?.('typ-product-page') ? [root] : root.querySelectorAll('typ-product-page');
    pages.forEach(page => {
      // Templates are emitted by Liquid, with Shopify's actual file reference URLs.
      const bank = new Map([...page.querySelectorAll('.tpb-media-bank template')].map(t => [t.dataset.typMediaTemplate, t]));
      page.querySelectorAll('[data-typ-media-key]').forEach(slot => {
        const template = bank.get(slot.dataset.typMediaKey);
        if (template && !slot.querySelector('img,video')) slot.replaceChildren(template.content.cloneNode(true));
      });
      if (page.dataset.tpbReady) return;
      page.dataset.tpbReady = 'true';
      page.addEventListener('click', event => {
        const pagination = event.target.closest('[data-faq-page-button]');
        if (pagination) {
          const faq = pagination.closest('.typology-faq-section');
          const selected = pagination.dataset.faqPageButton;
          faq.querySelectorAll('[data-faq-page]').forEach(p => { p.hidden = p.dataset.faqPage !== selected; });
          faq.querySelectorAll('[data-faq-page-button]').forEach(b => {
            const active = b === pagination;
            b.classList.toggle('is-active', active);
            if (active) b.setAttribute('aria-current', 'page'); else b.removeAttribute('aria-current');
          });
          return;
        }
        const button = event.target.closest('[data-tpb-select]');
        if (!button) return;
        const bundle = button.closest('[data-tpb-bundle]');
        const selected = button.dataset.tpbSelect;
        bundle.querySelectorAll('[data-tpb-select]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
        bundle.querySelectorAll('[data-tpb-copy]').forEach(p => { p.hidden = p.dataset.tpbCopy !== selected; });
        bundle.querySelectorAll('[data-tpb-media]').forEach(p => {
          p.hidden = p.dataset.tpbMedia !== selected;
          p.querySelectorAll('video').forEach(v => { if (p.hidden) v.pause(); else v.play()?.catch(() => {}); });
        });
      });
      // Native details controls layout. No measured min-height / ResizeObserver feedback loop.
      page.querySelectorAll('[data-tpb-media][hidden] video').forEach(v => v.pause());
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), {once:true});
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
